export default __webpack_public_path__ + "locales/hy-AM/SalesDepartmentRequestDialog.json?hash=43493cfbcad1d5e358332e46d1a5e090";